export default __webpack_public_path__ + "static/media/Investing.2d3f2111.svg";